import { render, staticRenderFns } from "./StopperComponent.vue?vue&type=template&id=9ea6e2a6&scoped=true&"
import script from "./StopperComponent.vue?vue&type=script&lang=ts&"
export * from "./StopperComponent.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ea6e2a6",
  null
  
)

export default component.exports